<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" >
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 v-if="open" class="modal-title">請選擇發送客戶「專屬邀請函」的版本</h3>
        </div>
        <div v-if="open" class="modal-body send-modal-body" style="min-height:220px;" :class="{'section-loading': sendLoading}">
          <table width="100%">
            <tr>
              <th width="25%"><a @click="choosestyle('A')"  class="btn btn-primary"  style="width:170px;height:62px;font-size:30px;">A.通用版</a></th>
              <th width="25%"><a @click="choosestyle('B')"  class="btn btn-primary"  style="width:170px;height:62px;font-size:30px;">B.伴侶版</a></th>
              <th width="25%"><a @click="choosestyle('C')"  class="btn btn-primary"  style="width:170px;height:62px;font-size:30px;">C.至親版</a></th>
              <th width="25%"><a @click="choosestyle('D')"  class="btn btn-primary"  style="width:170px;height:62px;font-size:30px;">D.子女版</a></th>
            </tr>
            <tr>
              <td width="25%" align="center" valign="center"><div @click="choosestyle('A')" style="cursor:pointer"><img :src="`${BaseUrl}assets/onlyuA.png`" width="140"></div></td>
              <td width="25%" align="center" valign="center"><div @click="choosestyle('B')" style="cursor:pointer"><img :src="`${BaseUrl}assets/onlyuB.png`" width="140"></div></td>
              <td width="25%" align="center" valign="center"><div @click="choosestyle('C')" style="cursor:pointer"><img :src="`${BaseUrl}assets/onlyuC.png`" width="140"></div></td>
              <td width="25%" align="center" valign="center"><div @click="choosestyle('D')" style="cursor:pointer"><img :src="`${BaseUrl}assets/onlyuD.png`" width="140"></div></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {commonMixin} from '@/mixins/common'

export default {
  name: 'LetterChoiceModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custs: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  computed: {
    ...mapGetters(['BaseUrl']),
  },
  data() {
    return {
      sendLoading: false,
      sendTypeName: '',
      sendType: 'A',
      sendCustData: {},
      tableData: [],
      tableDataBackup: [],
      ceapcnoList: [],
      visit_noList: [],
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    choosestyle(type) {  //打開 專函
      this.sendType = type
      this.$emit('send',this.sendType);
    }
  }
}
</script>
<style lang="scss" scoped>
.modal.fade {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: none;
  top: 0;
  left: 0;
  background: none;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &.warning {
    
    img {
      float: left;
    }
    .text {
      display: block;
      padding-top: 5px;
      margin: 0 0 20px 70px;
    }
    img,
    .text {
      vertical-align: middle;
    }
    .modal-body {
      min-height: 0;
    }
  }

  &.confirm .modal-body {
    min-height: 0;
  }

  &.has-backdoor {
    height: 99%;
    width: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: auto !important;
  }

  &:not(.has-backdoor):before {
    content: '';
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: block;
    top: 0;
    left: 0;
    opacity: 0;
    background: rgba(0,0,0,.6);
    transition: opacity .3s ease .3s !important;
  }

  &.is-out {
    &:before {
      opacity: 0;
    }

    .modal-dialog {
      opacity: 0;
      transform: translate(0, 25%);
    }
  }

  &.is-open {
    display: block;

    &:before {
      opacity: 1;
    }

    .modal-dialog {
      opacity: 1;
      transform: translate(0, 0%);
    }
  }

  .modal-dialog {
    position: relative;
    width: 900px;
    max-width: none;
    opacity: 0;
    transition: all .3s ease .5s !important;

    &.modal-lg {
      width: 900px;
    }
    &.modal-sm {
      width: 640px;
      margin: 20% auto;
    }

    .modal-content {
      margin: 10px auto 0px;
      border-radius: 12px;
    }
  }

  .modal-body {
    min-height: 500px;
    padding: 20px 40px;
  }

  .modal-header {
    background:  #F6FCF9;
    padding: 23px 40px;
    border-radius: 12px 12px 0 0;

    .close {
      position: absolute;
      font-size: 16px;
      width: 24px;
      height: 24px;
      right: 0;
      top: 0;
      margin-right: -12px;
      margin-top: -12px;
      display: block;
      color: #FFF;
      text-align: center;
      line-height: 24px;
      padding: 0;
      background:  #5B616A;
      border: 1px solid #FFF;
      border-radius: 12px;
      box-shadow: 0 0 4px 0 rgba(0,0,0,.8);
    }

    .modal-title {
      color: #027A39;
      margin: 0 auto 0 0;
    }
  }

  .pdf-preview {
    width: 100%;
    height: 420px;
    border: 1px solid #C2C4C7;
  }

  .maintain {
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

#group-modal {
  .modal-body {
    padding-top: 40px;
    .action {
      margin-top: 20px;
    }
  }
}

#new-record-modal {
  .mx-datepicker .mx-input-wrapper {
    padding-right: 30px;
    input.mx-input {
      margin-right: 30px;
    }

    .with-date-picker {
      line-height: 40px;
    }
  }

  .dropdown-menu.common-tag {
    padding: 20px 40px;
    width: 248px;
    left: -153%;
    right: 0;
    top: -23px;
  }

  .btn-grids {
    margin-left: -8px;
    margin-right: -8px;
    margin-top: 15px;
    .btn {
      position: relative;
      width: calc(25% - 16px);
      padding: 0;
      margin: 0 8px 15px;

      &.add-new {
        width: auto;
      }

      > [role="button"] {
        padding: 9px 24px;
      }

      .close {
        position: absolute;
        right: -10px;
        top: -10px;
      }
      &.is-edit {
        position: relative;
        border: 0;
        box-shadow: none;
        background: none;
        padding: 0;
      }

    }
  }
}

@media screen and (max-width: 768px) {
  .modal.fade {
    .modal-dialog.modal-sm,
    .modal-dialog {
      max-width: 100%;
      margin-left: 0;
      margin-right: 0;
      .modal-content {
        width: calc(100% - 20px);
        
        .modal-body {
          padding: 20px;
        }
      }
    }
  }
}
</style>
